import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = { revealScrollY: Number }

  get isVisible() {
    return !this.element.classList.contains(this.hiddenClass)
  }

  connect() {
    this.hiddenClass = 'cta-fixed-banner-hidden'
    this.closedByUser = false
  }

  onScroll(event) {
    if (window.scrollY > this.revealScrollYValue && this.isVisible === false && !this.closedByUser) {
      this.show()
    }
    if (window.scrollY < this.revealScrollYValue && this.isVisible === true) {
      this.hide()
    }
  }

  openFast(event) {
    event.preventDefault()
    document.dispatchEvent(new Event('openFast'))
    return false
  }

  show() {
    this.element.classList.remove('hidden')
    this.element.classList.remove(this.hiddenClass)
    this.element.querySelector('.cta-fixed-banner-content').classList.remove(this.hiddenClass)
    this.element.querySelector('.cta-fixed-banner-open-fast').classList.remove(this.hiddenClass)
  }

  hide() {
    this.element.classList.add(this.hiddenClass)
    this.element.querySelector('.cta-fixed-banner-content').classList.add(this.hiddenClass)
    this.element.querySelector('.cta-fixed-banner-open-fast').classList.add(this.hiddenClass)
  }

  close(event) {
    this.closedByUser = true
    this.hide()
  }
}
